module.exports = __webpack_public_path__ + "static/media/em-228.a284bf28.png";